import maButton from '@/components/buttons'
import maEventBus from '@/components/eventbus/index.js'
import { mapActions, mapMutations } from 'vuex'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_SINISTER_SUMMARY,
  WARRANTY_DELETE_DAMAGE,
  UPDATE_CART_IS_ACTIVE
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'

export default {
  name: 'cartModal',

  mixins: [flowMixin],

  data: function () {
    return {}
  },

  components: {
    maButton
  },

  props: {
    damagesList: Array
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetSinisterSummary: WARRANTY_GET_SINISTER_SUMMARY,
      actWarrantyDeleteDamage: WARRANTY_DELETE_DAMAGE
    }),

    ...mapMutations({
      updateCartIsActive: UPDATE_CART_IS_ACTIVE
    }),

    /**
     * Deletes the damage and emits and events that the damage was deletes
     */
    handleDeleteDamage(dataDamageId) {
      const damageId = dataDamageId
      const sinisterId = this.getSinisterId
      this.actWarrantyDeleteDamage({ damageId, sinisterId }).then(() => {
        this.actWarrantyGetSinisterSummary(sinisterId).then(() => {
          maEventBus.$emit('btnDelete:clicked')
          maEventBus.$emit('damageDeleted:cart')
        })
      })
    },

    /**
     * Pushes the route infromation for the to the confrimed damage-extra-details when a card is clicked, if its already in the damage details route it will update the damage id route nr and refresh the view
     */
    handleClickDamageDetail(dataDamageId) {
      const damageExtraDetailsViewName = 'damage-extra-details'
      const name = this.getDamageName
      const damageId = dataDamageId

      // We need to track if we came from cart because in that case, we have to hide "continue" button in dama-extra-details view
      this.updateCartIsActive(true)

      if (this.$route.name !== damageExtraDetailsViewName) {
        this.goToView(damageExtraDetailsViewName, { name, damageId })
        this.$emit('view:change')
      } else {
        // TO DO: temporal fix but this is wrong. Handle correctly redirect damage-extra-details from damage-extra-details
        this.$router.go(-1)
        setTimeout(() => {
          this.goToView(damageExtraDetailsViewName, { name, damageId })
          this.$emit('view:change')
        }, 100)
      }
    },

    /**
     * Modifies the subtitle
     */
    getSubtitle(subtitle) {
      if (subtitle.toUpperCase().indexOf('MUR') !== -1) {
        return 'Murs'
      } else {
        return subtitle
      }
    }
  }
}
